import moment from 'moment';

export const getIdsAndTime = (state) => {
  const momentToUnix = (time) => moment(time).unix();

  const { selectedAssets: ids, startTime, endTime } = state;
  const startTimeUnix = momentToUnix(startTime);
  const endTimeUnix = momentToUnix(endTime);
  return { ids, startTime: startTimeUnix, endTime: endTimeUnix };
};

export const getActiveAssetList = (assets) => {
  return assets
    .filter((item) => item.active)
    .map((item, index) => ({
      key: item.key,
      value: item.value,
      text: `[${index + 1}] ${item.label}`,
      name: item.label,
    }));
};

export const getDuration = (compareTo, compareWith) => {
  return parseInt(compareTo.diff(compareWith, 'days')) + 1;
};

export const getOrg = () => window.localStorage.getItem('organization');

export const filterDigitalIndicators = (data, assetsMap) => {
  const assetSensorPools = {};
  const getSensorsForAsset = (lastData) => [
    {
      index: 1,
      enabled:
        lastData.digital_input_sensor_1 === 'True' ||
        lastData.digital_input_sensor_1 === true,
      names: [
        (lastData.digital_input_sensor_1_name || '').trim().toLowerCase(),
        'digital input 1',
        'digital indicator 1',
        'digital_input_1',
        'digital_indicator_1',
      ].filter(Boolean),
    },
    {
      index: 2,
      enabled:
        lastData.digital_input_sensor_2 === 'True' ||
        lastData.digital_input_sensor_2 === true,
      names: [
        (lastData.digital_input_sensor_2_name || '').trim().toLowerCase(),
        'digital input 2',
        'digital indicator 2',
        'digital_input_2',
        'digital_indicator_2',
      ].filter(Boolean),
    },
    {
      index: 3,
      enabled:
        lastData.digital_input_sensor_3 === 'True' ||
        lastData.digital_input_sensor_3 === true,
      names: [
        (lastData.digital_input_sensor_3_name || '').trim().toLowerCase(),
        'digital input 3',
        'digital indicator 3',
        'digital_input_3',
        'digital_indicator_3',
      ].filter(Boolean),
    },
  ];

  return (data || []).filter((item) => {
    const assetName =
      item &&
      item.data &&
      item.data.asset_detail &&
      item.data.asset_detail.name;
    const assetLastData =
      (assetName && assetsMap[assetName]) || Object.values(assetsMap)[0];
    if (!assetLastData) return true;

    const poolKey = assetName || 'default';
    if (!assetSensorPools[poolKey]) {
      assetSensorPools[poolKey] = getSensorsForAsset(assetLastData);
    }

    const pool = assetSensorPools[poolKey];
    const name = (item.digital_indicator_name || '').trim().toLowerCase();

    const matchedIndex = pool.findIndex((sensor) =>
      sensor.names.includes(name),
    );

    if (matchedIndex !== -1) {
      const [matchedSensor] = pool.splice(matchedIndex, 1);
      return matchedSensor.enabled;
    }

    return false;
  });
};
